import { render, staticRenderFns } from "./SignSidebarMenu.vue?vue&type=template&id=0df81fae"
import script from "./SignSidebarMenu.vue?vue&type=script&lang=js"
export * from "./SignSidebarMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports